import { render, staticRenderFns } from "./PageSettingsSeo.vue?vue&type=template&id=d0e8815e&"
import script from "./PageSettingsSeo.vue?vue&type=script&lang=js&"
export * from "./PageSettingsSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports